import { render, staticRenderFns } from "./integration-service-data.vue?vue&type=template&id=e92bff50"
import script from "./integration-service-data.vue?vue&type=script&lang=js"
export * from "./integration-service-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports